<script setup>
import { computed } from 'vue';
const props = defineProps({
  initialActiveTab: {
    type: Number,
    default: 0,
  },
  tabs: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        tab =>
          typeof tab.label === 'string' &&
          (tab.count ? typeof tab.count === 'number' : true)
      );
    },
  },
});

const emit = defineEmits(['tabChanged']);

const activeTab = computed(() => props.initialActiveTab);

const selectTab = index => {
  emit('tabChanged', props.tabs[index]);
};

</script>

<template>
  <div class="flex items-center h-10 rounded-lg w-full gap-[6px]">
    <template v-for="(tab, index) in tabs" :key="index">
      <button
        class="relative truncate text-sm input-secondary transition-colors duration-300 ease-in-out bg-n-bluegray-5"
        :class="[
          activeTab === index
            ? 'text-n-gray-5 dark:text-n-gray-3 bg-n-gray-50 dark:bg-[#232833]'
            : 'text-n-bluegray-2 ',
        ]"
        @click="selectTab(index)"
      >
        {{ tab.label }} {{ tab.count ? `(${tab.count})` : '' }}
      </button>
      
    </template>
  </div>
</template>
